import getUrlForEnv, { services } from "@irati/utils/endpoints/getUrlForEnv";
var endpoints = {
    users: function () { return getUrlForEnv(services.IDENTITY_SERVICE, "/v2/users"); },
    unAuthedUser: function (uuid) { return getUrlForEnv(services.IDENTITY_SERVICE, "/v2/users/" + uuid + "/unauth"); },
    teams: function (tenantId) { return getUrlForEnv(services.IDENTITY_SERVICE, "/v2/tenants/" + tenantId + "/teams"); },
    tenants: function () { return getUrlForEnv(services.IDENTITY_SERVICE, "/v2/tenants"); },
    tenantGroups: function () { return getUrlForEnv(services.IDENTITY_SERVICE, "/v2/tenant-groups"); },
    subdomainHistory: function (tenantId) { return getUrlForEnv(services.IDENTITY_SERVICE, "/v2/tenants/" + tenantId + "/subdomains"); }
};
export default endpoints;
